// extracted by mini-css-extract-plugin
export var borderRadius = "_b3-4";
export var large = "_b3-3";
export var logoContainer = "_b3-0";
export var nameLogo = "_b3-2";
export var small = "_b3-1";